export const PLAN_TYPE = {
	SERVICE: 'service',
	STORAGE: 'storage',
	TRIAL: 'trial',
	MONTHLY: 'monthly',
	QUARTERLY: 'quarterly',
	YEARLY: 'yearly'
};
